module.exports = "/subscriptions/assets/e12c23d850c35279520c5410e147d966.png";